'use client';

import { type ReactNode, createContext, useRef, type JSX } from 'react';

import type { IssuesState } from '../store/IssuesStore';
import { createIssuesStore } from '../store/IssuesStore';

export type IssuesStoreApi = ReturnType<typeof createIssuesStore>;

export type IssuesStoreProviderProps = {
    children: ReactNode;
    issuesState?: IssuesState;
};

// TODO: Refactor this later to use the correct naming convention
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IssuesStoreContext = createContext<IssuesStoreApi | undefined>(undefined);

export function IssuesStoreProvider({ children, issuesState }: IssuesStoreProviderProps): JSX.Element {
    const storeRef = useRef<IssuesStoreApi>(undefined);

    if (!storeRef.current) {
        storeRef.current = createIssuesStore(issuesState);
    }

    return <IssuesStoreContext.Provider value={storeRef.current}>{children}</IssuesStoreContext.Provider>;
}
